import React, {cloneElement, Fragment, useState} from 'react';
import {Button, Form, Modal} from "react-bootstrap";
import BranchForm from "./BranchForm";
import {editBranchAsync, updateBranchRoamingAddressAsync} from "../../../app/store/reducers/branch/branchReducer";
import {useDispatch, useSelector} from "react-redux";
import {selectLang, Translate} from "../../../app/store/reducers/main/mainReducer";
import IconButton from "../../common/IconButton";
import {FormProvider, useForm} from "react-hook-form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import checkPermission from "../../../enum/Permission/CheckPermission";
import {PermissionBranchUpdate} from "../../../enum/Permission/RolePermission";
import toastPermission from "../../../enum/Permission/ToastPermission";
import {toast} from "react-toastify";

const EditBranchModal = ({branch, children, ...props}) => {
    const [isRoamingAddressExist, setIsRoamingAddressExist] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [existName, setExistName] = useState('');
    const [existCode, setExistCode] = useState('');
    const [show, setShow] = useState(false);
    const lang = useSelector(selectLang);
    const dispatch = useDispatch();
    const t = Translate;

    const methods = useForm({
        defaultValues: {
            name: null,
            code: null,
            inn: null,
            roamingBranch: {
                branch_name: null,
                branch_number: null,
            },
            location: {
                latitude: 41.311151,
                longitude: 69.279737,
                address: 'сквер Амира Темура',
            }
        },
    });

    const handleShow = () => {
        if (dispatch(checkPermission(PermissionBranchUpdate))) {
            initDefaultValues();
            setShow(true);
        } else {
            dispatch(toastPermission());
        }
    };

    const handleClose = () => {
        methods.reset();
        setShow(false);
    };

    const initDefaultValues = () => {
        methods.setValue('name', branch.name);
        methods.setValue('code', branch.code);
        methods.setValue('inn', branch.inn);
        methods.setValue('roaming_branch.branch_name', branch.roaming_branch?.branch_name);
        methods.setValue('roaming_branch.branch_number', branch.roaming_branch?.branch_number);

        if (branch.roaming_address) {
            methods.setValue('regionCode', branch.roaming_address.region_code);
            methods.setValue('regionName', branch.roaming_address.region_name);
            methods.setValue('districtCode', branch.roaming_address.district_code);
            methods.setValue('districtName', branch.roaming_address.district_name);
            methods.setValue('villageCode', branch.roaming_address.village_code);
            methods.setValue('villageName', branch.roaming_address.village_name);
            methods.setValue('street', branch.roaming_address.street);
            methods.setValue('other', branch.roaming_address.other);
            if (branch.roaming_address && branch.roaming_address.latitude && branch.roaming_address.longitude) {
                methods.setValue('location', {
                    latitude: branch.roaming_address.latitude,
                    longitude: branch.roaming_address.longitude,
                    address: '',
                });
            } else if (branch.roaming_branch && branch.roaming_branch.latitude && branch.roaming_branch.longitude) {
                methods.setValue('location', {
                    latitude: branch.roaming_branch.latitude,
                    longitude: branch.roaming_branch.longitude,
                    address: branch.roaming_branch.address,
                });
            }
            setIsRoamingAddressExist(true);
        }
    };

    const onSubmit = async (formData) => {
        try {
            setIsLoading(true);

            // edit branch
            await editBranchAsync(branch.id, {
                name: formData.name,
                code: formData.code,
                roaming_branch: {
                    branch_name: formData.roaming_branch.branch_name,
                    branch_number: formData.roaming_branch.branch_number,
                }
            });

            // update roaming address
            const roamingAddressInfoExist = !!formData.regionCode && !!formData.districtCode
            if (roamingAddressInfoExist) {
                const updatePayload = {
                    region_code: formData.regionCode,
                    region_name: formData.regionName,
                    district_code: formData.districtCode,
                    district_name: formData.districtName,
                    village_code: formData.villageCode,
                    village_name: formData.villageName,
                    street: formData.street,
                    other: formData.other,
                    longitude: formData.location.longitude,
                    latitude: formData.location.latitude,
                };
                await updateBranchRoamingAddressAsync(branch.id, updatePayload)
            }

            toast.success(t(lang, 'common.toast.success'));
            handleClose();
        } catch ({nameExists, codeExists}) {
            if (nameExists)
                return setExistName(formData.name);

            if (codeExists)
                return setExistCode(formData.code)

            return toast.error(t(lang, 'common.toast.error'))
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Fragment>
            {!!children ? cloneElement(children, {...children.props, onClick: handleShow}) : (
                <IconButton variant={'falcon-primary'} size={'sm'} icon={'plus'} onClick={handleShow} {...props}>
                    {t(lang, 'edi.common.add_button')}
                </IconButton>
            )}

            <Modal show={show} onHide={handleClose} size={'lg'}>
                <FormProvider {...methods}>
                    <Form onSubmit={methods.handleSubmit(onSubmit)}>
                        <Modal.Header closeButton={true}>
                            <Modal.Title>{t(lang, 'edi.branch.edit-form.title')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <BranchForm branchId={branch.id} existingName={existName} existingCode={existCode}
                                        roamingAddressExist={isRoamingAddressExist} isEditing={true}/>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant={'secondary'} type={'button'} onClick={handleClose}>
                                {t(lang, 'edi.common.button.close')}
                            </Button>
                            <Button variant={'primary'} type={'submit'} disabled={isLoading}>
                                {isLoading && <FontAwesomeIcon pulse={true} className="me-2" icon="spinner"/>}
                                <span>{t(lang, 'edi.common.button.save')}</span>
                            </Button>
                        </Modal.Footer>
                    </Form>
                </FormProvider>
            </Modal>
        </Fragment>
    );
};
export default EditBranchModal;
